import { roleInstance } from 'Interfaces/roleBasedAccessInterfaces';

interface tmsAllowRoles {
  tmsRowEditButton: roleInstance[];
  newTmsAddButton: roleInstance[];
  tmsModalStrategyEditDropDown: roleInstance[];
  tmsModalUpdateButton: roleInstance[];
  tmsModalFutureHistoryDeleteButton: roleInstance[];
}

interface ndcAllowRoles {
  ndcSingleEditButton: roleInstance[];
  ndcMultiEditButton: roleInstance[];
  ppsPpsStrategyEdit: roleInstance[];
  newPpsPpsStrategyAdd: roleInstance[];
  segmentationEdit: roleInstance[];
  newSegmentationAdd: roleInstance[];
  dpStrategyEdit: roleInstance[];
  newDpStrategyAdd: roleInstance[];
  ndcModalHistoryDeleteButton: roleInstance[];
  // addPPSAndPPSSC: roleInstance[],
  // editPPSAndPPSSC: roleInstance[],
  // addSegmentationAndDPStrategy: roleInstance[],
  // editSegmentationAndDPStrategy: roleInstance[],
}

// [{ department: "pricing", role: "basicUser" }, { department: "pricing", role: "admin" }, { department: "pricing", role: "superUser" }, { department: "salesOps", role: "basicUser" }, { department: "salesOps", role: "admin" }{ department: "salesOps", role: "superUser" }]

export const tmsAllowRoles: tmsAllowRoles = {
  tmsRowEditButton: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  newTmsAddButton: [{ department: 'salesOps', role: 'superUser' }],
  tmsModalStrategyEditDropDown: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  tmsModalUpdateButton: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  tmsModalFutureHistoryDeleteButton: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
};

export const ndcAllowedRoles: ndcAllowRoles = {
  ndcSingleEditButton: [
    { department: 'pricing', role: 'admin' },
    { department: 'pricing', role: 'superUser' },
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  ndcMultiEditButton: [
    { department: 'pricing', role: 'admin' },
    { department: 'pricing', role: 'superUser' },
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  ppsPpsStrategyEdit: [
    { department: 'pricing', role: 'admin' },
    { department: 'pricing', role: 'superUser' },
  ],
  newPpsPpsStrategyAdd: [{ department: 'pricing', role: 'superUser' }],
  segmentationEdit: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  newSegmentationAdd: [{ department: 'salesOps', role: 'superUser' }],
  dpStrategyEdit: [
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
  newDpStrategyAdd: [{ department: 'salesOps', role: 'superUser' }],
  ndcModalHistoryDeleteButton: [
    { department: 'pricing', role: 'admin' },
    { department: 'pricing', role: 'superUser' },
    { department: 'salesOps', role: 'admin' },
    { department: 'salesOps', role: 'superUser' },
  ],
};
